import React, { ReactElement, SVGProps } from "react";
import BaseIcon from "./BaseIcon";

export default function ArrowRightIcon(props: SVGProps<any>): ReactElement {
  return (
    <BaseIcon {...props}>
      <path
        d="M3.75 12h16.5M13.5 5.25 20.25 12l-6.75 6.75"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </BaseIcon>
  );
}
